import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class TeamSeeMoreProfiles extends withBreakpointObserver(Base) {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'TeamSeeMoreProfiles',
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Mount the component.
   * @returns {void}
   */
  mounted() {
    this.teamCards = document.querySelectorAll('.team-card--additionnal');
    this.open = false;
  }

  /**
   * Show all profiles on click
   */
  onClick() {
    this.open = !this.open;

    this.teamCards.forEach((element) => {
      element.classList.toggle('s:hidden');
    });

    this.$el.textContent = this.open ? this.$el.dataset.labelClose : this.$el.dataset.labelOpen;
  }
}
